import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { DEFAULT_CONTENT } from "../data/defaults";
import { SITE } from "../data/site";
import { API } from "../lib/api";


export const fileUrl = (path) => `${API}/files/${path}`;

const SiteDataCtx = createContext({
  content: {},
  images: {},
  gallery: null,
  refresh: () => {},
});

export const SiteDataProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [images, setImages] = useState({});
  const [gallery, setGallery] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    const [c, i, g] = await Promise.allSettled([
      axios.get(`${API}/content`),
      axios.get(`${API}/images`),
      axios.get(`${API}/gallery`),
    ]);
    if (c.status === "fulfilled") setContent(c.value.data.data || {});
    if (i.status === "fulfilled") setImages(i.value.data.images || {});
    if (g.status === "fulfilled") setGallery(g.value.data.items || []);
    setLoaded(true);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <SiteDataCtx.Provider value={{ content, images, gallery, loaded, refresh: load }}>
      {children}
    </SiteDataCtx.Provider>
  );
};

export const useSiteData = () => useContext(SiteDataCtx);

// Sunucudan gelen içerik ile varsayılanları birleştirir.
// Boş string / boş dizi bırakılan alanlarda varsayılan geçerli olur.
const mergeContent = (content) => {
  const merged = { ...DEFAULT_CONTENT };
  Object.entries(content || {}).forEach(([k, v]) => {
    if (v == null || v === "") return;
    if (Array.isArray(v) && v.length === 0) return;
    merged[k] = v;
  });
  return merged;
};

export const useC = () => mergeContent(useSiteData().content);

const normPhone = (p) => {
  let d = (p || "").replace(/\D/g, "");
  if (d.startsWith("0")) d = d.slice(1);
  if (d.startsWith("90")) d = d.slice(2);
  return `+90${d}`;
};

export const useSite = () => {
  const c = useC();
  return {
    name: SITE.name,
    fullName: SITE.fullName,
    shortLabel: SITE.shortLabel,
    phone: c.site_phone,
    phoneHref: `tel:${normPhone(c.site_phone)}`,
    whatsapp: (c.site_whatsapp || "").replace(/\D/g, ""),
    address: c.site_address,
    addressCity: c.site_address_city,
    city: c.site_city,
    since: c.site_since,
    facebook: c.site_facebook,
    instagram: c.site_instagram,
  };
};

export const useWa = (msg = "Merhaba, Yalı Yurt hakkında bilgi almak istiyorum.") => {
  const { whatsapp } = useSite();
  return `https://wa.me/${whatsapp}?text=${encodeURIComponent(msg)}`;
};
